import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import styled from 'styled-components';


export default function Navigation(){
  const router = useRouter();

  const nodes = router.asPath.split('/');

  let secondLevel = null;
  if(nodes[1] === 'catalog' && nodes[2]) secondLevel = 'Алфавитный указатель';
  else if(nodes[1] === 'catalog') secondLevel = 'Каталог';
  else if(nodes[1] === 'articles') secondLevel = 'Новости и статьи';
  else if(nodes[1] === 'text' && nodes[2] === 'about') secondLevel = 'О компании';
  else if(nodes[1] === 'text' && nodes[2] === 'contact') secondLevel = 'Контакты';
  else if(nodes[1] === 'text' && nodes[2] === 'information') secondLevel = 'Юридическая информация';
  else if(nodes[1] === 'search' && nodes[2]) {
    if (router.query.search === 'object') {
      secondLevel = `Поиск по аптеке`;
    } else if (router.query.obj_id) {
      secondLevel = `Поиск: ${router.query.search}`;
    } else {
      secondLevel = isNaN(+nodes[2]) ? `Поиск: ${decodeURI(nodes[2])}` : 'Поиск';
    }
  }
  else if(nodes[1] === 'cart') secondLevel = `Моя корзина`;
  else if(nodes[1] === 'pharmacies') secondLevel = `Аптека`;

  return secondLevel && <Container>
    <div className="maxwidth">
      <NavigationBox>
        <span><Link href="/">Главная</Link></span>&nbsp;&nbsp;/&nbsp;&nbsp;<span>{secondLevel}</span>
      </NavigationBox>
    </div>
  </Container>
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  border-bottom: 1px solid #eee;
`

const NavigationBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 40px;
  color: #989898;

  & span:first-child {
    color: var(--color-text);
  }
`